import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll/modules';

import { StringKeyValue } from '../../../actions/types';
import KycForm from '../../../components/Kyc/KycForm';
import Loader from '../../../components/Loader/Loader';
import StepButtons from '../../../components/Steps/StepButtons';
import { LoaderReducer } from '../../../reducers/loader';

interface Props {
    ssn: string;
    previousEvent: () => void;
    completeEvent: (status: string) => void;
    text: StringKeyValue;
    loader: LoaderReducer;
    skipEvent?: () => void;
    skipKycEnabled?: boolean;
}

const LoanCompletionKyc = ({
    ssn,
    previousEvent,
    completeEvent,
    text,
    loader,
    skipEvent,
    skipKycEnabled,
}: Props): JSX.Element => {
    useEffect(() => {
        setTimeout(() => {
            scroll.scrollToTop();
        }, 200);
    }, []);
    if (loader.isUpdatingApplication) return <Loader title={text.loadingDefault} />;
    return (
        <div className="kyc">
            <KycForm ssn={ssn} previousEvent={() => previousEvent()} completeEvent={completeEvent} />
            {skipEvent && skipKycEnabled && (
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <StepButtons showNext nextChangeEvent={() => skipEvent()} nextButtonName="Skip KYC" />
                </div>
            )}
        </div>
    );
};

export default LoanCompletionKyc;
